import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import _isEqual from 'lodash/isEqual';
import _debounce from "lodash/debounce";

import {ContractForm, ConfirmModal} from '../common';
import {
    QUICK_CALCULATION_CHECKSUM,
    QUICK_CALCULATION_DATA,
} from '../../constants/localStorageConstants';
import {addContract, addContractFailed, isModalAddContract} from '../../redux/actions/contractAction';
import {requestForCalculationFailed, resetCalculations} from '../../redux/actions/quickCalculationAction';
import {messages} from '../../helpers/messages';
import { debtNotificationError, riskMessage, waitingMessage } from '../../helpers/data-constants';
import { getClientLastDebtLoad, getDebtLoadGroupRequest } from '../../redux/actions/debtLoadAction';
import { debtHandbookFields } from '../DebtToIncomeRatio/helpers';
import useClientValidation from './useClientValidation.hook';

import './client.scss';
import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_content-card.scss';
import '../../assets/styles/components/_content-tabs.scss';
import '../../assets/styles/components/_collapse.scss';
import '../../assets/styles/components/_dropdown.scss';

import ClearIcon from '../../assets/icons/clear.svg';
import {cashboxReset} from '../../redux/actions/handbookAction';
import { DebtLoadDataForm } from '../common/DebtLoadCalculation';
import {Message} from "../utilites";
import BasicAlert from "../utilites/Alert/Alert";

const ClientContractAdd = ({onError}) => {
    const {commonError, contractID, isLoading, isModal} = useSelector(({contract}) => contract);
    const {
        commonError: calculationError, calculations, loading
    } = useSelector(({quickCalculation}) => quickCalculation);
    const {accessFeatures} = useSelector(({user}) => user);
    const { client } = useSelector(({ clientInfo }) => clientInfo);
    const { debtCalculateError, debtLoadCalculation } = useSelector(({ debtLoad }) => debtLoad);
    const [isClearForm, setIsClearForm] = useState(false);
    const [isContractAdd, setIsContractAdd] = useState(false)
    const [contextForm, setContextForm] = useState(null)
    const [debtError, setDebtError] = useState(null)
    const [contextCalculationLayout, setContextCalculationLayout] = useState(null)
    const [basicAlertMessage, setBasicAlertMessage] = useState(loading)
    const [isDebtLoadData, setIsDebtLoadData] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const clientId = +history.location.pathname.split('/')[2];
    const { validateClientId } = useClientValidation({client});
    const isHighRiskClient = client?.serviceInformation?.riskFinal === 'Высокий'
    const isDisabled = calculationError || calculations.availableAmount < 0 || debtCalculateError || basicAlertMessage
    const isDebtLoadCalculation = calculations.calculateDebtLoad && clientId
    const data = JSON.parse(localStorage.getItem(QUICK_CALCULATION_DATA));

    useEffect(() => setIsClearForm(false), [isClearForm]);
    useEffect(() => setBasicAlertMessage(null), [loading]);

    useEffect(() => {
        setIsContractAdd(false)
    }, [commonError]);

    useEffect(() => {
        if (calculations.availableAmount < 0) {
            onError(messages[15399])
            window.scrollTo(0, 0);
        } else {
            onError('')
        }
    }, [calculations.availableAmount])

    useEffect(() => {
        return () => dispatch(addContractFailed(''))
    }, [])

    useEffect(() => {
        if (contractID) history.push(`/client/${clientId}/contracts/${contractID}`);

        return () => {
            localStorage.removeItem(QUICK_CALCULATION_DATA);
            dispatch(resetCalculations());
        };
    }, [contractID, dispatch]);

    const clearForm = () => {
        localStorage.removeItem(QUICK_CALCULATION_DATA);
        setIsClearForm(true);
    };

    const submitForm = () => {
        const data = JSON.parse(localStorage.getItem(QUICK_CALCULATION_DATA));
        const checksum = localStorage.getItem(QUICK_CALCULATION_CHECKSUM);
        let positions;
        if (
            ((
                    data?.purities &&
                    !_isEqual(data.purities, [])
                    && !data.purities.find(({pureWeight, grossWeight}) => pureWeight === '0' || grossWeight === '0',)
                    && !data.purities.find(({jewel}) => jewel.length === 0)
                )
                || (data?.things && !_isEqual(data.things, {}) && data.things.name)
                || (
                    data?.cars
                    && !_isEqual(data.cars, {})
                    && data.cars.makeOfCar
                    && data.cars.model
                    && data.cars.year.value
                    && data.cars.carNumber
                    && data.cars.marketPrice
                    && data.cars.estimatedPrice
                    && data.cars.registrationNumber
                    && data.cars.registrationDate
                    && data.cars.VIN
                    && data.cars.garage
                    && data.cars.condition
                )
            )
            && data?.calculation
            && !_isEqual(data.calculation, {})
        ) {
            if (data.typeTab === 0) {
                positions = data.purities.map(
                    ({jewel, quantity, purity, grossWeight, pureWeight, puritiesComment, isPart, additionalInfo}) => ({
                        type: 'PURITY',
                        names: [jewel.label],
                        quantity: +quantity,
                        comment: puritiesComment,
                        purityId: +purity.value,
                        grossWeight: +grossWeight,
                        pureWeight: +pureWeight,
                        isPart: isPart,
                        additionalInfo: accessFeatures['purities.additional_info'] ? additionalInfo : ''
                    }),
                );
            } else if (data.typeTab === 1) {
                positions = [
                    {
                        type: 'THINGS',
                        serialNumber: data.things.sn,
                        quantity: +data.things.quantity,
                        estimatedValue: +data.things.estimatedValue,
                        comment: '',
                        imei: data.things.imei,
                        model: data.things.model,
                        names: [data.things.name],
                        additionalInfo: data.things.additionalInfo
                    },
                ];
            } else if (data.typeTab === 2) {
                positions = [
                    {
                        type: 'CARS',
                        names: [data.cars.makeOfCar.label,],
                        model: data.cars.model.label,
                        carDate: +data.cars.year.value,
                        registrationNumber: data.cars.carNumber,
                        quantity: 1,
                        marketPrice: +data.cars.marketPrice,
                        estimatedValue: +data.cars.estimatedPrice,
                        certificateNumber: data.cars.registrationNumber,
                        certificateDate: data.cars.registrationDate,
                        vin: data.cars.VIN,
                        stateOFTheVehicle: data.cars.condition.trim(),
                        additionalInformation: data.cars.additionalInfo,
                        storageInCashBox: data.cars.garage === 'C хранением в ломбарде',
                        comment: '',
                    },
                ];
            }
            const newContract = {
                checksum,
                positions,
                endDate: data.calculation.endDate,
                amount: +data.calculation.amount,
                clientId,
                couponId: data.coupon.value,
                cashBoxId: data.cashbox.value,
                waiverOfRedemption: data.calculation.waiverOfRedemption,
                additionalInformation: data.additionalInformation,
                isNonCash: data.calculation.isNonCash,
                dealForm: data.dealForm,
                months: data.calculation.months?.value,
                firstPaymentDate: data.calculation?.firstPaymentDate
            };
            onError('');
            dispatch(addContract(newContract, clientId));
            dispatch(cashboxReset())
            handleCloseModal()
        } else {
            onError(messages[10]);
            window.scrollTo(0, 0)
        }
    };

    const handleOpenModal = () => {
        dispatch(isModalAddContract(true));
    }

    const handleCloseModal = () => {
        dispatch(isModalAddContract(false));
    }

    const handleSaveButton = _debounce(async() => {
        const { calculation } = JSON.parse(localStorage.getItem(QUICK_CALCULATION_DATA));

        if(debtLoadCalculation && Number(calculation.amount) !== calculations.amount) {
            setBasicAlertMessage(waitingMessage);
            return
        }
        const errorMessages = validateErrors();
        if (errorMessages) return;

        if (contextCalculationLayout && contextForm) {
            const resultContextForm = await contextForm.trigger()
            const resultCalculationLayout = await contextCalculationLayout.trigger()
            if (resultContextForm && resultCalculationLayout) {
                handleOpenModal()
                setIsContractAdd(true);
            } else {
                onError(messages[10])
            }
        } else {
            handleOpenModal()
            setIsContractAdd(true);
        }
    }, 300)

    const validateErrors = () => {
        if (calculations.calculateDebtLoad && !debtLoadCalculation) {
            setDebtError(debtNotificationError);
            return true;
        }
        if (validateClientId(true)) return true;
        return false;
    };

    const handleOpenDebtLoadModal = () => {
        setIsDebtLoadData(true);
        dispatch(getClientLastDebtLoad(client.id));
        dispatch(getDebtLoadGroupRequest(debtHandbookFields.AVG_INDUSTRY_INCOME))
      };

      const handleCloseDebtLoadModal = () => {
        setIsDebtLoadData(false)
      }

    const goBack = () => {
        history.push(`/client/${clientId}/contracts`);
        dispatch(cashboxReset())
        handleCloseModal()
        setIsContractAdd(false)
    };

    const handleLocalCloseModal = () => {
        handleCloseModal()
        setIsContractAdd(false)
    }

    const closeAlert = () => {
        dispatch(requestForCalculationFailed(calculationError))
        setDebtError(null)
    }

    const modalHeaderText = () => {
        if (debtLoadCalculation?.isDebtOverloaded && isContractAdd) {
            return 'Значение ПДН превышает 40%. Вы уверены что хотите оформить микрозаём?';
        }
        return isContractAdd ? 'Выполнить создание договора?' : 'Отменить создание договора?';
    };

    return (
        <div className="content-inner-data-container">
            {calculationError && <Message type='error' text={calculationError}/>}
            {isHighRiskClient && <Message type='warning' text={riskMessage}/>}
            <div className="content-section-title contractAdd-section-title">
                <h2 className="contractAdd-header">
                    <strong>
                        <big>Создание нового договора</big>
                    </strong>
                </h2>
                <div className="action-items contractAdd-action-items">
                    <button className="button-icontrigger caption" type="button" onClick={clearForm}>
            <span className="icon">
              <ClearIcon/>
            </span>
                        <span>Очистить форму</span>
                    </button>
                </div>
            </div>

            <ConfirmModal
                isOpen={isModal}
                handleClose={isContractAdd ? handleLocalCloseModal : handleCloseModal}
                handleAction={isContractAdd ? submitForm : goBack}
                headerText={modalHeaderText()}
                bodyText={isContractAdd ? '' : 'Внесённые данные в договор не сохранятся.'}
                loading={isLoading}
            />

            <ContractForm contextCalculationLayout={contextCalculationLayout}
                          setContextCalculationLayout={setContextCalculationLayout}
                          setContextForm={setContextForm}
                          isClear={isClearForm}
                          loadSavedData={true}
                          onError={onError}
                          clientId={clientId}
                          isDebtLoadData={isDebtLoadData}
                          handleCloseDebtLoadModal={handleCloseDebtLoadModal}
                          currentDealDuration={data?.calculation?.months?.value}
            />
            <div className="content-inner-data-container-footer d-flex flex-direction-row">
                <div className='d-flex flex-1'>
                    <button
                        className={(calculationError || calculations.availableAmount < 0) ? "button-icontrigger-disabled" : "button"}
                        type="button"
                        onClick={handleSaveButton}
                        disabled={isDisabled}>
                        Сохранить
                    </button>
                    <button className="button-light" onClick={handleOpenModal}>
                        Отменить
                    </button>
                </div>
                <div className='d-flex flex-1'>
                    {isDebtLoadCalculation && (
                    <button
                        className="button"
                        type="button"
                        onClick={handleOpenDebtLoadModal}
                    >
                        Рассчитать ПДН
                    </button>
                    )}
                </div>
                <DebtLoadDataForm
                    isOpen={isDebtLoadData}
                    onClose={handleCloseDebtLoadModal}
                    currentDealAmount={calculations?.amount}
                    currentDealDuration={data?.calculation?.months?.value}
                    typeCreateDeal={data?.typeContractTab}
                    />
            </div>
            <BasicAlert onClose={() => closeAlert(false)}
                        message={calculationError || debtError || basicAlertMessage}
                        isOpen={calculationError || debtError || basicAlertMessage}
                        isError={!basicAlertMessage}/>
        </div>
    );
};

export default ClientContractAdd;
